"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportTemplatesFactory = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const uuid_1 = require("uuid");
const evidence_1 = require("../../../composite/evidence-2/evidence");
const DictionaryEvidence = __importStar(require("../../../composite/evidence-2/dictionary-evidence/dictionary-evidence"));
const export_context_1 = require("../export-context");
const export_templates_colums_1 = require("./export-templates-colums");
const export_templates_schema_1 = require("./export-templates-schema");
const export_templates_fields_1 = require("./export-templates-fields");
const export_api_1 = require("../export-api");
const template_context_1 = require("./context/template-context");
function exportTemplatesFactory({ exportTag, defaultSorts, enableDocx4j, }) {
    return function ExportTemplates() {
        const intl = react_intl_1.useIntl();
        const { url } = react_1.useContext(export_context_1.ExportContext);
        const validationSchema = export_templates_schema_1.useValidationSchema();
        const columns = export_templates_colums_1.useColumns();
        const evidence = DictionaryEvidence.useDictionaryEvidence({
            version: 2,
            identifier: 'EXPORT_TEMPLATES',
            apiProps: {
                url: `${url}/templates`,
                getItem: export_api_1.getItem,
                updateItem: export_api_1.updateItem,
                createItem: export_api_1.createItem,
            },
            tableProps: {
                columns,
                tableName: intl.formatMessage({
                    id: 'EAS_EXPORT_TEMPLATES_TABLE_TITLE',
                    defaultMessage: 'Šablony exportu',
                }),
                reportTag: exportTag,
                defaultSorts,
            },
            detailProps: {
                FieldsComponent: export_templates_fields_1.ExportTemplatesFields,
                validationSchema,
                initNewItem: () => ({
                    id: uuid_1.v4(),
                    name: '',
                    params: '{}',
                }),
                toolbarProps: {
                    title: intl.formatMessage({
                        id: 'ES__EXPORT_TEMPLATES__DETAIL__TITLE',
                        defaultMessage: 'Šablona exportu',
                    }),
                },
            },
        });
        return (react_1.default.createElement(template_context_1.TemplateContext.Provider, { value: { enableDocx4j: enableDocx4j !== null && enableDocx4j !== void 0 ? enableDocx4j : false } },
            react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence))));
    };
}
exports.exportTemplatesFactory = exportTemplatesFactory;
exportTemplatesFactory.useExportDataProviders = export_api_1.useExportDataProviders;
exportTemplatesFactory.useExportDesignProviders = export_api_1.useExportDesignProviders;
exportTemplatesFactory.useColumns = export_templates_colums_1.useColumns;
exportTemplatesFactory.useValidationSchema = export_templates_schema_1.useValidationSchema;
exportTemplatesFactory.Fields = export_templates_fields_1.ExportTemplatesFields;
//# sourceMappingURL=export-templates.js.map